import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty, uniqBy, cloneDeep } from 'lodash';
import CustomDatePicker from '../Utility/DatePicker/DatePicker';
import { fetchBomReferenceSupplier } from '../../Pages/Library/BomLibrary/store/BomLibrary.action';
import { SystemMasterSelect } from '../helper';
import '../../Pages/DevlopmentOrder/Testing/Testing.css';

const initialState = {
  status: '',
  supplier: null,
  selectedDate: null,
  comment: '',
};

const forModalBtns = (hideSupplier) => {
  return hideSupplier ? 'status1_0' : 'status1_1';
};

const forOrignalBtns = (hideSupplier) => {
  return hideSupplier ? 'status_0' : 'status_1';
};

const fromDevId = (fromModal, status_0, hideSupplier) => {
  return fromModal ? status_0 : forOrignalBtns(hideSupplier);
};

const disablingCondition = (fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable) => {
  return (
    (!fromBomExpand && !fromProductTesting && !fromTestingLib && !fromProductCareLabel && !fromSampleMissingComponent && isDisable) ||
    ((fromTestingLib || fromProductTesting || fromProductCareLabel || fromBomExpand || fromSampleMissingComponent) && btnsDisable)
  );
};

function ApproveRejectFooter({
  selectedIdArray,
  selectedIdsArray,
  devOrderId,
  selectedTab,
  hideSupplier,
  suppliersList,
  onSave,
  selectedExpand,
  disabledSaveBtn,
  userInfo,
  selectedRefCode,
  cardList,
  fromBomExpand,
  btnsDisable,
  fromProductTesting,
  fromProductCareLabel,
  fromTestingLib,
  status_0,
  status_1,
  fromModal,
  fromBomList,
  fromSampleMissingComponent,
  careBtnsDisable,
  isDisabledState,
  fromSupplierDocumentComponent,
}) {
  const { t } = useTranslation('common');

  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails } = ProductTestingData;
  const { isSupplierLoggedIn } = UserDetails;
  const { isProductArchived } = BOMConfigDetails;
  const locallySourced = 'Locally Sourced';
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [selectedDate, setDate] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const [supplier, setSupplier] = useState(null);
  const [supplierForSelect, setSupplierForSelect] = useState(suppliersList);
  const [hasError, setHasError] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [commentError, setCommentError] = useState(false);
  const [comment, setComment] = useState(null);

  useEffect(() => {
    if (!fromBomExpand) {
      if (!isEmpty(selectedIdArray)) {
        let commonSupplierArray = [];
        let hasLocallySrced = [];
        selectedIdArray?.forEach((ele, eleIndex) => {
          cardList?.forEach((element) => {
            if (element.libId === ele) {
              if (!isEmpty(element.BOMSupplier)) {
                if (eleIndex === 0) {
                  element?.BOMSupplier?.forEach((bomSuppEle) => {
                    if (bomSuppEle.name === locallySourced) {
                      hasLocallySrced = true;
                      commonSupplierArray.push(...suppliersList);
                    } else {
                      commonSupplierArray.push(bomSuppEle);
                    }
                  });
                } else {
                  const arr = cloneDeep(commonSupplierArray);
                  const newTempArr = [];
                  element.BOMSupplier.forEach((bomEle) => {
                    arr.forEach((arrEle, arrindex) => {
                      if (arrEle._id !== bomEle?._id && arr.length > element.BOMSupplier?.length) {
                        if (hasLocallySrced) {
                          arr.forEach((newElements) => {
                            if (bomEle.name === locallySourced) {
                              suppliersList.forEach((suEle) => {
                                if (newElements._id === suEle?._id) {
                                  newTempArr.push(newElements);
                                }
                              });
                            } else if (newElements._id === bomEle?._id) {
                              newTempArr.push(newElements);
                            }
                          });
                          commonSupplierArray = uniqBy(newTempArr, '_id');
                        } else {
                          const array = cloneDeep(commonSupplierArray);
                          element.BOMSupplier.forEach((combinationEle) => {
                            array.forEach((arrayEle, arrayIndex) => {
                              if (arrayEle._id !== combinationEle?.componentSupplier?._id && array?.length > element?.BOMSupplier?.length) {
                                commonSupplierArray.splice(arrayIndex, 1);
                              }
                            });
                          });
                          commonSupplierArray.splice(arrindex, 1);
                        }
                      }
                    });
                  });
                }
              } else if (!isEmpty(element.combinationSuppliers)) {
                if (eleIndex === 0) {
                  element.combinationSuppliers.forEach((combEle) => {
                    if (combEle.componentSupplier.name === locallySourced) {
                      hasLocallySrced = true;
                      commonSupplierArray.push(...suppliersList);
                    } else {
                      commonSupplierArray.push(combEle.componentSupplier);
                    }
                  });
                } else {
                  const newarr = cloneDeep(commonSupplierArray);
                  const tempArray = [];
                  element.combinationSuppliers.forEach((coEle) => {
                    newarr.forEach((arrEle) => {
                      if (arrEle._id !== coEle?.componentSupplier?._id && newarr?.length > element?.combinationSuppliers?.length) {
                        if (hasLocallySrced) {
                          newarr.forEach((newElements) => {
                            if (coEle?.componentSupplier?.name === locallySourced) {
                              suppliersList.forEach((suEle) => {
                                if (newElements._id === suEle?._id) {
                                  tempArray.push(newElements);
                                }
                              });
                            } else if (newElements._id === coEle?.componentSupplier?._id) {
                              tempArray.push(newElements);
                            }
                          });
                          commonSupplierArray = uniqBy(tempArray, '_id');
                        } else {
                          const newarray = cloneDeep(commonSupplierArray);
                          element.combinationSuppliers.forEach((combinationEle) => {
                            newarray.forEach((arrayEle, arrayIndex) => {
                              if (arrayEle._id !== combinationEle?.componentSupplier?._id && newarray?.length > element?.combinationSuppliers?.length) {
                                commonSupplierArray.splice(arrayIndex, 1);
                              }
                            });
                          });
                        }
                      }
                    });
                  });
                }
              }
            }
          });
        });
        if (fromSupplierDocumentComponent) {
          setIsDisable(false);
        } else {
          setIsDisable(isEmpty(commonSupplierArray));
        }
        setSupplierForSelect(uniqBy([...commonSupplierArray], '_id'));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray, cardList, suppliersList, fromBomExpand]);

  useEffect(() => {
    if (isDisable) {
      setValue('supplier', '', {
        shouldValidate: false,
      });
      setValue('status', 0, {
        shouldValidate: false,
      });
      setSupplier(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisable]);

  const handleDropdownChange = (value) => {
    setValue('supplier', value, { shouldValidate: true });
    setSupplier(value);
  };

  const handleDateChange = (date) => {
    setDate(date);
  };

  const handleCommentData = (data) => {
    setComment(data);
    const inputLength = data.length;
    setCommentCount(inputLength);
  };

  const onSubmitMethod = async (data) => {
    if (!selectedDate || (!comment && fromProductCareLabel)) {
      if (!selectedDate) {
        setHasError(true);
      } else {
        setCommentError(true);
      }
    } else {
      !fromBomExpand && setIsDisable(disabledSaveBtn);
      const obj = {
        ...data,
        commentDate: selectedDate || data.selectedDate,
        approveBy: userInfo.userId,
      };

      if (hideSupplier) {
        const colourData =
          selectedIdArray && selectedIdArray.length > 0
            ? selectedIdArray.map((item) => ({
                supplier: item?.supplier,
                parentId: item?.parentId,
                childId: item?.childId,
                colourRefNumber: item?.colourRefNumber,
                colourRef: item?.colourRef?._id || '',
              }))
            : [];
        if (!fromProductTesting && !fromTestingLib && fromBomExpand && !fromProductCareLabel) {
          obj.refCode = selectedRefCode;
          obj.libId = selectedExpand?.libId || '';
          obj.bomId = selectedExpand?._id || '';
          obj.colourData = colourData;
        }
      } else if (!fromProductTesting && !fromProductCareLabel && !fromTestingLib && (fromBomExpand || fromBomList)) {
        obj.refCodes = selectedRefCode;
        obj.bomLibIds = selectedIdArray;
        obj.bomIds = selectedIdsArray;
        obj.supplierId = data?.supplier?._id || '';
      }
      delete obj.supplier;
      delete obj.selectedDate;
      const value = obj;
      const id = selectedTab?._id || '';
      if (fromProductTesting || fromTestingLib || fromSampleMissingComponent) {
        onSave(devOrderId, value);
        setValue('result', '');
      } else {
        onSave(id, devOrderId, value);
      }
      for (const [key, val] of Object.entries(initialState)) {
        if (key === 'selectedDate') {
          setDate(val);
          setHasError(false);
        }
        if (key === 'supplier') {
          setSupplier(val);
        }

        if (key === 'comment') {
          setComment(val);
          setCommentError(false);
        }
        setValue(key, val);
        !fromBomExpand && setIsDisable(disabledSaveBtn);
        setCommentCount(0);
      }
    }
  };

  return (
    !isSupplierLoggedIn &&
    !isProductArchived && (
      <div className="common-approve-reject-footer">
        <div className="radio-date-container">
          <div className="approve-reject">
            <div className="d-flex align-items-center">
              <p className="custom-radio mb-0 mr-16">
                <input
                  type="radio"
                  id={fromDevId(fromModal, status_0, hideSupplier)}
                  name="status"
                  value={1}
                  {...register('status', { required: true })}
                  disabled={
                    isDisabledState ||
                    disablingCondition(
                      fromBomExpand,
                      fromProductTesting,
                      fromProductCareLabel,
                      fromTestingLib,
                      fromSampleMissingComponent,
                      isDisable,
                      btnsDisable,
                    )
                  }
                />
                <label className="m-0 text-bold" htmlFor={fromDevId(fromModal, status_0, hideSupplier)}>
                  {t('APPROVE_REJECT_FOOTER.APPROVED')}
                </label>
              </p>
              <p className="custom-radio mb-0 mr-16">
                <input
                  type="radio"
                  id={fromModal ? status_1 : forModalBtns(hideSupplier)}
                  name="status"
                  value={0}
                  {...register('status', { required: true })}
                  disabled={
                    isDisabledState ||
                    disablingCondition(
                      fromBomExpand,
                      fromProductTesting,
                      fromProductCareLabel,
                      fromTestingLib,
                      fromSampleMissingComponent,
                      isDisable,
                      btnsDisable,
                    )
                  }
                />
                <label className="m-0 text-bold" htmlFor={fromModal ? status_1 : forModalBtns(hideSupplier)}>
                  {t('APPROVE_REJECT_FOOTER.REJECTED')}
                </label>
              </p>
              {errors.status && <span className="error-message xs-position-bottom">{t('APPROVE_REJECT_FOOTER.STATUS_REQUIRED')}</span>}
            </div>
          </div>
          <div className="date">
            <div className="input-button-container">
              <CustomDatePicker
                valueProp={selectedDate}
                dateFormat="dd-MMM-yyyy"
                popperPlace="top-end"
                name="selectedDate"
                onChange={(date) => handleDateChange(date)}
                disable={
                  isDisabledState ||
                  disablingCondition(
                    fromBomExpand,
                    fromProductTesting,
                    fromProductCareLabel,
                    fromTestingLib,
                    fromSampleMissingComponent,
                    isDisable,
                    btnsDisable,
                  )
                }
              />
              {hasError && !selectedDate && <span className="error-message">{t('APPROVE_REJECT_FOOTER.DATE_REQUIRED')}</span>}
            </div>
          </div>
        </div>
        {hideSupplier || fromProductTesting || fromTestingLib || fromProductCareLabel || fromSampleMissingComponent || fromSupplierDocumentComponent ? null : (
          <div className="supplier  mr-3">
            <div className="custom-react-select">
              <Select
                menuPlacement="top"
                options={supplierForSelect}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                name="supplier"
                value={supplier}
                styles={SystemMasterSelect}
                {...register('supplier', {
                  required: true,
                })}
                onChange={handleDropdownChange}
                isDisabled={isDisabledState || (!fromBomExpand && isDisable) || (fromBomExpand && btnsDisable)}
              />
              {errors.supplier && <span className="error-message">{t('APPROVE_REJECT_FOOTER.SUPPLIER_SELECTION_REQUIRED')}</span>}
            </div>
          </div>
        )}

        {(fromProductTesting || fromTestingLib) && (
          <div className="note">
            <input
              type="text"
              name="result"
              className="form-control"
              placeholder={t('APPROVE_REJECT_FOOTER.RESULT')}
              {...register('result', {
                required: false,
              })}
              disabled={
                isDisabledState ||
                disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable)
              }
            />
          </div>
        )}

        <div className="note-btn-container">
          <div className="note">
            <input
              type="text"
              name="comment"
              className="form-control pr-40"
              placeholder={fromSupplierDocumentComponent ? t('APPROVE_REJECT_FOOTER.STATUS_COMMENTS') : t('APPROVE_REJECT_FOOTER.COMMENT_PLACEHOLDER')}
              {...register('comment', {
                required: false,
              })}
              maxLength="80"
              value={comment}
              onChange={(e) => handleCommentData(e.target.value)}
              disabled={
                isDisabledState ||
                disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable)
              }
            />
            <span className="char-count">{commentCount}/80</span>
            {commentError && !comment && <span className="error-message">{t('APPROVE_REJECT_FOOTER.COMMENT_REQUIRED')}</span>}
          </div>
        </div>
        <div className="button-container">
          <button
            className="btn p-0"
            onClick={handleSubmit(onSubmitMethod)}
            type="button"
            aria-label="save"
            disabled={
              disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable) ||
              careBtnsDisable ||
              isDisabledState
            }
          >
            <span className="icon-Save-1 f-24" />
          </button>
          <button
            className="btn btn-default bg-white ml-2 d-md-none"
            onClick={handleSubmit(onSubmitMethod)}
            type="button"
            aria-label="Save"
            disabled={
              isDisabledState ||
              disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable)
            }
          >
            <span className="icon-Save" />
          </button>
        </div>
      </div>
    )
  );
}

const mapStateToProps = ({ BomLibraryDetails, UserDetails, BOMConfigDetails }) => {
  const { userInfo } = UserDetails;
  const { ReferenceSupplier } = BomLibraryDetails;
  const { cardList } = BOMConfigDetails;
  return {
    ReferenceSupplier,
    userInfo,
    cardList,
  };
};

const mapStateToDispatch = {
  fetchBomReferenceSupplier,
};

export default connect(mapStateToProps, mapStateToDispatch)(ApproveRejectFooter);
